import { render, staticRenderFns } from "./SplitTest.vue?vue&type=template&id=13eb9308&scoped=true&lang=pug"
import script from "./SplitTest.vue?vue&type=script&lang=js"
export * from "./SplitTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eb9308",
  null
  
)

export default component.exports